export const en = {
    entityInterfaces: {
        alerts: {
            create: {
                title: "Create Entity Interface",
                text: "Are you sure you want to create <b>%{entityInterface}</b>",
                success: {
                    title: "Entity Interface Created Successfully",
                    text: "<b>%{entityInterface}</b> was created successfully",
                },
                error: {
                    title: "Entity Interface Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Entity Interface",
                text: "Are you sure you want to delete <b>%{entityInterface}</b>",
                success: {
                    title: "Entity Interface Deleted Successfully",
                    text: "You will now be redirected to the Entities page",
                },
                error: {
                    title: "Entity Interface Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Entity Interface",
                text: "Are you sure you want to edit <b>%{entityInterface}</b>",
                success: {
                    title: "Entity Interface Edited Successfully",
                    text: "<b>%{entityInterface}</b> was edited successfully",
                },
                error: {
                    title: "Entity Interface Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        list: {
            name: "Name",
            category: "Category",
            lastReading: "Last Reading",
            lastCommunication: "Last Communication",
        },
        form: {
            headers: {
                create: "Create Entity Interface",
                edit: "Edit Entity Interface",
                view: "View Entity Interface"
            },
            name: {
                label: "Name",
            },
            category: {
                label: "Category",
            },
            entity: {
                label: "Entity",
            },
        },
    }
};